import { all, fork } from 'redux-saga/effects';

import coreSaga from './core.saga';
import dashboardSaga from './dashboard.saga';
import interventionLeadsSaga from './intervention.saga';

export default function* leadsSaga() {
  yield all([fork(coreSaga), fork(dashboardSaga), fork(interventionLeadsSaga)]);
}
